import axios from 'axios'
import NProgress from 'nprogress'
import { store } from '../store/store'
import { AUTH0_DOMAIN, AUTH0_CLIENT_ID } from '../utils/constants'

export default () => {
  const headers = { 'content-type': 'application/json' }
  const userString = localStorage.getItem('reveles-user')
  if (userString) {
    const user = JSON.parse(userString)
    headers.authorization = 'Bearer ' + user.id_token
  }
  const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_ROOT_API,
    headers: headers,
    crossdomain: true
  })
  // before a request is made start the nprogress
  const env = process.env.VUE_APP_ENV; let url = ''; let t = null; let organization_id = ''

  axiosInstance.interceptors.request.use(config => {
    NProgress.start()
    organization_id = store.getters.currentOrganization.entity_id
    url = config.url.includes('?') ? config.url.split('?')[0] : config.url
    t = performance.now()
    return config
  })

  // before a response is returned stop nprogress
  axiosInstance.interceptors.response.use(response => {
    NProgress.done()
    console.log('Environment: ' + env, ', Organization ID: ' + organization_id, ', API: ' + url, ', Time: ' + (performance.now() - t))
    return response
  })
  return axiosInstance
}

export function Auth0MfaApi (mfaToken) {
  const headers = { 'content-type': 'application/json' }
  headers.authorization = 'Bearer ' + mfaToken
  const axiosInstance = axios.create({
    baseURL: 'https://' + AUTH0_DOMAIN,
    headers: headers,
    crossdomain: true
  })
  // before a request is made start the nprogress
  axiosInstance.interceptors.request.use(config => {
    NProgress.start()
    return config
  })

  // before a response is returned stop nprogress
  axiosInstance.interceptors.response.use(response => {
    NProgress.done()
    return response
  })
  return axiosInstance
}
